/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Could_Not_Load_FilesInputs */

const en_mobile_could_not_load_files = /** @type {(inputs: Mobile_Could_Not_Load_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load your files. Pull to refresh.`)
};

const es_mobile_could_not_load_files = /** @type {(inputs: Mobile_Could_Not_Load_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar tus archivos. Desliza para actualizar.`)
};

/**
* | output |
* | --- |
* | "Couldn't load your files. Pull to refresh." |
*
* @param {Mobile_Could_Not_Load_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_could_not_load_files = /** @type {((inputs?: Mobile_Could_Not_Load_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Could_Not_Load_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_could_not_load_files(inputs)
	return en_mobile_could_not_load_files(inputs)
});